<template>
  <div class="card p-4 shadow-sm">
    <!-- Botón de regreso -->
    <button
      class="btn btn-outline-secondary btn-sm mb-3"
      @click="$router.push('/inicio')"
      type="button"
    >
      <i class="bi bi-arrow-left me-1"></i> Regresar
    </button>

    <h3 class="text-center mb-3">Resumen de Efectivo</h3>

    <div class="mb-3">
      <label class="form-label">Seleccionar Fecha</label>
      <input type="date" v-model="fecha" @change="obtenerResumen" class="form-control" />
    </div>

    <div id="voucher-area" v-if="resumen" style="width: 300px; font-family: monospace;" class="mx-auto">
      <div class="mb-3 text-center">
        <h5>{{ brand.nombreCorto }}</h5>
        <p>Resumen de Efectivo<br>{{ formatearFecha(fecha) }}</p>
      </div>

      <div class="mb-3">
        <p><strong>Facturado</strong></p>
        <p>Total: Q{{ resumen.efectivo_facturado.toFixed(2) }} <br>Depositar a: </p>
        <p style="white-space: pre-line">
Cuenta:
{{ obtenerTextoCuenta(cuentaFacturado) }}</p>
      </div>

      <div class="mb-3">
        <p><strong>Sin factura</strong></p>
        <p>Total: Q{{ resumen.efectivo_no_facturado.toFixed(2) }}<br>Depositar a:</p>
        <p style="white-space: pre-line">
Cuenta:
{{ obtenerTextoCuenta(cuentaNoFacturado) }}</p>
      </div>
    </div>

    <!-- Selectores -->
    <div v-if="resumen">
      <label>Cuenta Facturado:</label>
      <select v-model="cuentaFacturado" class="form-select mb-3">
        <option disabled value="">Seleccione una cuenta</option>
        <option v-for="cuenta in cuentasBancarias" :key="cuenta.IdCuentaBancaria" :value="cuenta.IdCuentaBancaria">
          {{ cuenta.Banco }} - {{ cuenta.NumeroCuenta }} ({{ cuenta.NombreCuenta }} / {{ cuenta.tipocuenta?.Tipo }})
        </option>
      </select>

      <label>Cuenta Sin factura:</label>
      <select v-model="cuentaNoFacturado" class="form-select mb-4">
        <option disabled value="">Seleccione una cuenta</option>
        <option v-for="cuenta in cuentasBancarias" :key="cuenta.IdCuentaBancaria" :value="cuenta.IdCuentaBancaria">
          {{ cuenta.Banco }} - {{ cuenta.NumeroCuenta }} ({{ cuenta.NombreCuenta }} / {{ cuenta.tipocuenta?.Tipo }})
        </option>
      </select>

      <!-- Botón imprimir -->
      <div class="text-end">
        <button class="btn btn-dark" @click="imprimirVoucher">
          🖨 Imprimir Voucher
        </button>
      </div>
    </div>

    <div v-if="error" class="alert alert-danger mt-3">
      {{ error }}
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '@/config/config';
import { BRAND } from '@/config/branding';

export default {
    name:'DepositoEfectivo',
  data() {
    return {
      brand: BRAND,
      fecha: new Date().toLocaleDateString('fr-CA'),
      resumen: null,
      cuentasBancarias: [],
      cuentaFacturado: '',
      cuentaNoFacturado: '',
      error: ''
    };
  },
  mounted() {
    this.obtenerCuentasBancarias();
    this.obtenerResumen();
  },
  methods: {
    async obtenerResumen() {
      this.error = '';
      this.resumen = null;
      try {
        const res = await axios.get(`${API_URL}/resumen-efectivo-caja`, {
          params: { fecha: this.fecha }
        });
        this.resumen = res.data;
      } catch (err) {
        this.error = 'Error al obtener resumen de efectivo.';
        console.error(err);
      }
    },
    async obtenerCuentasBancarias() {
      try {
        const res = await axios.get(`${API_URL}/cuentas-bancarias`);
        this.cuentasBancarias = res.data;
      } catch (err) {
        console.error('Error al cargar cuentas bancarias', err);
      }
    },
    formatearFecha(fecha) {
      return fecha.split('-').reverse().join('/');
    },
    obtenerTextoCuenta(idCuenta) {
      const cuenta = this.cuentasBancarias.find(c => c.IdCuentaBancaria === idCuenta);
      if (!cuenta) return '---';
      return `${cuenta.Banco} - ${cuenta.NumeroCuenta} - ${cuenta.NombreCuenta}` +
             (cuenta.tipocuenta?.Tipo ? ` / ${cuenta.tipocuenta.Tipo}` : '');
    },
    imprimirVoucher() {
  const area = document.getElementById('voucher-area');
  const contenido = `
    <html>
      <head>
        <title>Voucher</title>
        <style>
          @media print {
            body {
              margin: 0;
              padding: 0;
              width: 80mm;
              font-family: monospace;
              font-size: 12px;
            }
            * {
              box-sizing: border-box;
            }
            .text-center {
              text-align: center;
            }
            p {
              margin: 0 0 5px 0;
            }
            .firma-section {
              margin-top: 15px;
              font-size: 12px;
            }
            .linea {
              border-bottom: 1px solid #000;
              width: 100%;
              margin: 3px 0 8px 0;
            }
          }
        </style>
      </head>
      <body>
        ${area.innerHTML}

        <div class="firma-section">
          <p><strong>Nombre:</strong></p>
          <div class="linea"></div>

          <p><strong>Firma:</strong></p>
          <div class="linea"></div>

          <p><strong>Número de Depósito:</strong></p>
          <div class="linea"></div>
        </div>

      </body>
    </html>
  `;

  const ventana = window.open('', '', 'width=300,height=600');
  ventana.document.write(contenido);
  ventana.document.close();
  ventana.focus();
  ventana.print();
  ventana.close();
}

  }
};
</script>

<style scoped>
select, input {
  font-size: 14px;
}
</style>
